module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"product_option":"商品选项","positive":"满意","neutral":"一般","negative":"有待改进","expand_review":"查看更多","collapse_review":"显示较少"}}')
  delete Component.options._Ctor
}
